module.exports = __webpack_public_path__ + "img/illustrations-discount-alternative.c194780f.svg";